import {React} from 'react'

const PageHeader = ({title}) => {
    return (
        <div className="page-header mt-3 mb-4">
            <h1>{title}</h1>
            <span className="border-bottom">&nbsp;</span>
        </div>
    )
}

export default PageHeader
